import { Formik, Form } from 'formik'
import React, { useContext, useState } from 'react'
import AppNavigation from '../../AppNavigation'
import { AppContext } from '../../../App'
import ResinousCoveCoverageDetailsModals from './ResinousCoveCoverageDetailsModals'
import * as Yup from 'yup'
import axios from 'axios'
import config from '../../../config.json'
import { CustomInputTotalArea, CustomSelect, CustomChipAndColorFields } from './resinousFormInputs'

export default function ResinousCoveCoverageDetailsForm() {
   const {
      setAppHeader,
      setCurrentStep,
      stepsCompleted,
      setStepsCompleted,
      setCoverageDetails,
      productOptionsSelected,
      setCalculatedProducts,
      setSelectedChip,
      setSelectedColor,
      availableColors,
       availableChipColors,
       availableSmallColors,
       availableLargeColors,
       availableSmallChipColors,
       availableLargeChipColors,
       setAvailableColors,
       setAvailableChipColors,
      unit,
      setUnit,
      colorValue,
      setColorValue,
      chipValue,
      setChipValue,
      metricAreaToImperialArea,
      toastNotify,
      setApiError,
      setColorImage,
      setChipImage,
      colorImage,
       chipImage,
       bu,
       iso,
       setColorSku,
       setColorChipSku,
       setColorCoverage,
       setColorChipCoverage
   } = useContext(AppContext)
   
   const [stateLength, setStateLength] = useState()
   const [stateHeight, setStateHeight] = useState()
   const [stateChipValue, setStateChipValue] = useState()
    const [stateColorValue, setStateColorValue] = useState()
    const [statePreferredPackagingSize, setStatePreferredPackagingSize] = useState()
    const systemName = productOptionsSelected.productOptions[3].toLowerCase()

    const handlePreferredPackagingSizeChange = value => {
        // Reset color and chip selectors to initial blank state
        setStateChipValue()
        setStateColorValue()
        setChipImage()
        setColorImage()
        // If value does not equal "Select", set value in state. Else reset state.
        if (value !== "Select") {
            setStatePreferredPackagingSize(value)
        } else {
            setStatePreferredPackagingSize()
        }
        console.log(availableSmallChipColors)
            setAvailableColors(
                value === "Small" ? (
                    availableSmallColors
                ) : (
                    availableLargeColors
                )
            )
            setAvailableChipColors(
                value === "Small" ? (
                    availableSmallChipColors
                ) : (
                    availableLargeChipColors
                )
            ) 
    }

    console.log(availableColors)

    const handleFormSubmission = (formData) => {
       console.log("submit")

      // Add the input data to state of App.
      setCoverageDetails({ formData })

      // Capture form data.
      const { length, height } = formData

      // If unit is metric, convert length to imperial for calculation (to linear feet)
      let convertedLength = unit==="m" ? (
         length * metricAreaToImperialArea // THIS IS NOW IN FEET
         // 3.28084 
      ) : (
         length // THIS IS STILL IN FEET
      )
      // Isolate inches value from "height" variable, which is a string that includes " in."
      let heightInFeet = height/12
      let totalArea = convertedLength * heightInFeet

      function fetchCalculation(systemName) {
      
         // Prepare the API URL depending on form data.
         const apiUrlRoot = config.resinousMainCalculationEndpoint
         const subCategory = "cove"
         const addOnVaporBan = "no"
         const addOnClinicalPlus = "no"
         const addOnExtraTopCoat = "no"
         const addOnMvb = "no"
          const apiCompleteUrl = apiUrlRoot + "/" + unit + "/" + systemName + "/" + subCategory + "/" + addOnVaporBan + "/" + addOnMvb + "/" + addOnClinicalPlus + "/" + addOnExtraTopCoat + "/" + bu + "/" + iso + "/" + totalArea

      // Fetch the calculated products and information for the quote based on the URL parameters.
      axios.get(apiCompleteUrl)
         .then(res => {
               // Set the response data in state on <App> for retrieval on quote screen.
               setCalculatedProducts(res.data)
               const message = "Success! Quote created."
               const type = "success"
               toastNotify(message, type)
         })
         .catch(error => {
               console.log(error)
               setApiError(error)
               const message = "Something went wrong and the quote could not be created."
               const type = "error"
               toastNotify(message, type)
         })
      }


      // Send user selections to API for calculation.
      fetchCalculation(systemName)
      // Update the current step.
      setCurrentStep({ step: "resinousCoveQuoteCreated" })
      // Update the steps completed to include this step.
      stepsCompleted.push("Provide Coverage Details")
      setStepsCompleted(stepsCompleted)
      // Set the appHeader for Step state.
      setAppHeader("Quote created.")
      // Set the selected chip and color.
      setSelectedChip(chipValue)
      setSelectedColor(colorValue)
   }


   // Set unique validation schema depending on system name. Epoxy has no colors, Urethane Cement has no chips (quartz).
   const validationSchema = systemName.toLowerCase().indexOf('urethane') > -1 ? (
      {
      length: Yup.number()
         .required('This field is required.')
         .positive('This value must be positive.'),
      unit: Yup.string()
         .required('Select ft&#178; or m&#178;'),
      height: Yup.string()
         .oneOf(['4','6'])
         .required('This field is required.'),
      colorSelection: Yup.string()
          .oneOf(availableColors.map(color => color.Name))
         .required('This field is required.'),
      preferredPackagingSize: Yup.string()
         .oneOf(['Small','Large'])
         .required('This field is required.')
      }
   ) : (
      {
      length: Yup.number()
         .required('This field is required.')
         .positive('This value must be positive.'),
      unit: Yup.string()
         .required('Select ft&#178; or m&#178;'),
      height: Yup.string()
         .oneOf(['4','6'])
         .required('This field is required.'),
      chipSelection: Yup.string()
          .oneOf(availableChipColors.map(chip => chip.Name))
         .required('This field is required.')  ,
      preferredPackagingSize: Yup.string()
         .oneOf(['Small','Large'])
         .required('This field is required.')
      }
       )

    const formProps = isSubmitting => (
            <Form>
                <CustomInputTotalArea
                    label="Total Length of Cove Base (Linear Feet or Meters)"
                    name="length"
                    type="number"
                    placeholder="Enter length"
                    unit={unit}
                    setUnit={setUnit}
                    isCove={true}
                    onBlur={(e) => setStateLength(e.target.value)}
                />
                <CustomSelect label="Select Height" name="height" onBlur={(e) => setStateHeight(e.target.value)}>
                    <option value="Select">Select</option>
                    <option value="4">4 in.</option>
                    <option value="6">6 in.</option>
            </CustomSelect>
            {
                <CustomSelect
                    label="Preferred Packaging Size*"
                    name="preferredPackagingSize"
                    onChange={(e) => handlePreferredPackagingSizeChange(e.target.value)}
                >
                    <option key={'Select'} value={'Select'}>Select</option>
                    <option value="Small">Small</option>
                    <option value="Large">Large</option>
                </CustomSelect>
            }
                {
                    (availableSmallColors.length > 0 || availableLargeColors.length > 0) &&
                    <CustomChipAndColorFields
                        label="Color Selection"
                        name="colorSelection"
                        id="colorSelection"
                        image={colorImage}
                        colorType="color"
                        onChange={(e) => setColorValue(e.target.value)}
                        disabled={!statePreferredPackagingSize ? true : false} // If preferred packaging size has not yet been set, set this option as not available to select value yet.
                    />
                }
                {
                    (availableSmallChipColors.length > 0 || availableLargeChipColors.length > 0) &&
                    <CustomChipAndColorFields
                        label="Quartz Selection"
                        name="chipSelection"
                        id="chipSelection"
                        colorType="quartz"
                        image={chipImage}
                        onChange={(e) => setChipValue(e.target.value)}
                        disabled={!statePreferredPackagingSize ? true : false} // If preferred packaging size has not yet been set, set this option as not available to select value yet.
                    />
                }
                <button className="btn btn-primary" type="submit">{ isSubmitting ? 'Loading...' : 'CALCULATE'}</button>
            </Form>
        )
    

   return (
      <React.Fragment>
         <div className="col-xs-12 col-md-9 col-md-push-3">
            <h3>Provide Coverage Details</h3>
            <Formik
               initialValues={{
                       length: stateLength || '',
                       unit: 'sqft',
                  height: stateHeight || 'Select',
                  chipSelection: stateChipValue || '',
                       colorSelection: stateColorValue || '',
                       preferredPackagingSize: statePreferredPackagingSize || ''
               }}
               enableReinitialize
               validateOnChange={false}
               validateOnBlur={false}
               validationSchema={ Yup.object().shape(validationSchema) }
               onSubmit={ (values) => handleFormSubmission(values) }
               >
                   {props => formProps(props.isSubmitting)}
            
            </Formik>
         </div>
         <AppNavigation />
         <ResinousCoveCoverageDetailsModals
            availableColors={ availableColors }
               availableChipColors={availableChipColors}
            setChipValue={ setChipValue }
            setColorValue={ setColorValue }
            setStateChipValue={ setStateChipValue }
            setStateColorValue={ setStateColorValue }
            setColorImage={ setColorImage }
               setChipImage={setChipImage}
               setColorSku={setColorSku}
               setColorChipSku={setColorChipSku}
               setColorCoverage={setColorCoverage}
               setColorChipCoverage={setColorChipCoverage}
            systemName={ systemName }
         />
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousCoveCoverageDetails.js